// src/auth/RequireAuth.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth() {
    const { isLoggedIn } = useAuth();

    // ✅ ถ้า login แล้ว → render route ปกติ
    // ❌ ถ้ายังไม่ login → เด้งไปหน้า /login
    return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
}
